import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTranslation } from "react-i18next";

const HistoryTypeSelector = ({ 
  value, 
  onChange, 
  list, 
}) => {
  const { t } = useTranslation();
  return (
    <ToggleButtonGroup
      color="primary"
      value={value}
      size="small"
      exclusive
      onChange={(e,v) => v && onChange(v)}
    >
      {
        list.map((filter) => (
          <ToggleButton 
            value={filter.value}
            key={filter.value}
            sx={(theme) => ({
              textTransform: 'none',
              fontWeight: 600,
              fontSize: {
                xs: '0.75rem',
                sm: '0.875rem',
              },
              '&.Mui-selected': {
                color: theme.palette.text.primary,
                textTransform: 'none',
                border: '1px solid',
                borderColor: theme.palette.primary.main,
                // backgroundColor: theme.palette.primary.main,
                // color: 'white',
              }

            })}
          >
            { filter.icon }
            {t(filter.translationKey)}
          </ToggleButton>
        ))
      }
    </ToggleButtonGroup>
  );
}

export default HistoryTypeSelector